import { render, staticRenderFns } from "./BayItemName.vue?vue&type=template&id=35e0a80d&scoped=true&"
import script from "./BayItemName.vue?vue&type=script&lang=js&"
export * from "./BayItemName.vue?vue&type=script&lang=js&"
import style0 from "./BayItemName.vue?vue&type=style&index=0&id=35e0a80d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0a80d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e0a80d')) {
      api.createRecord('35e0a80d', component.options)
    } else {
      api.reload('35e0a80d', component.options)
    }
    module.hot.accept("./BayItemName.vue?vue&type=template&id=35e0a80d&scoped=true&", function () {
      api.rerender('35e0a80d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/coms/BayItemName.vue"
export default component.exports